// extracted by mini-css-extract-plugin
export var required = "_ob-0";